import {FETCH_CARS, FETCH_MODEL_BRAND, SET_CAR_PAGINATION_DATA} from "./types";

const initialState = {
    carsInfo: [],
    paginationData: {
      total_pages: 1,
      next: '',
      previous: ''
    },
    filter: {
        max: 0,
        min: 0,
    },
    modelbrand: []
}

export const carsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CARS:
            return {...state, carsInfo: action.payload}
        case FETCH_MODEL_BRAND:
            return {...state, modelbrand: action.payload}
        case SET_CAR_PAGINATION_DATA:
            return {...state, paginationData: {
                total_pages: action.payload.total_pages,
                    next: action.payload.next,
                    previous: action.payload.previous
                }}
        default:
            return state
    }
}
